<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-link
          style="font-size: 18px; color: #fff;"
          :to="{ path: `/traffic-sub?DeptID=${deptid}`}"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="12"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80; font-size: 16px"> แยกจราจรอัจฉริยะ🚦 </span><br>
          <span style="color: #fff; font-size: 16px"> {{ detail }} </span>
        </b-link>
        <a :href="anydesk">
          <b-button
            size="sm"
            class="large-dropdown text-small"
            variant="outline-danger"
          ><b-img
            src="@/assets/images/logo/anydesk.png"
            style="height: 10px; width: 10px;"
          /></b-button>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BButton, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BImg,
    // BLink,
    BButton,
    BRow,
    BCol,
    BLink,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      items: [],
      deptid: '',
      detail: '',
      anydesk: '',
      // anydesk1: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getMarkerTraffic()
  },
  mounted() {
    this.getCurrentTime()
    this.interval = setInterval(() => {
      this.getMarkerTraffic()
    }, 300000)
  },
  methods: {
    getCurrentTime() {
      axios
        .post('/getPieTrafficDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.deptid = response.data[0].deptid
          this.detail = response.data[0].detail
          this.anydesk = `anydesk:${response.data[0].anydesk}`
          console.log(112233, this.anydesk)
        })
        .catch(error => {
          console.log(error)
        })
    },

    getMarkerTraffic() {
      axios
        .post('/getMarkerTrafficDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.center = []
          this.center = [response.data[0].longitude, response.data[0].latitude]
          this.center = [response.data[0].longitude, response.data[0].latitude]
          this.detail = this.items[0].detail
          this.lastupdate = this.items[0].lastupdate
          console.log(2255, this.detail)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style >
.chart1{
  display: block;
  margin-left: auto;
  margin-right: auto;
    }
.hero::before {
    content: "";
    background: url(~@/assets/images/traffic/Jucntion.jpg) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 98%;
    height: 95%;
    opacity: 0.6;
  }
  .hero1::before {
    content: "";
    background: url(~@/assets/images/traffic/traffic3-1.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 95%;
    height: 90%;
    opacity: 0.6;
  }

</style>
